import { Action, State, types } from '.';
import { RegistrationStep } from '../../../utils/constValues';
import Workflow from '../../../models/workflow';
import { WorkflowContext } from 'src/utils/constValues';
import { storeWorkflowContextData, getWorkflowContextData } from 'src/utils/workflow';

export const initWorkflow = (): Workflow => {
    let workflow = {
        sessionId: '',
        currentStep: RegistrationStep.ProviderInformation,
        isCurrentStepFinished: false,
        currentStepHasErrors: false
    };

    return workflow;
};

export const storeWorkingRegistrationId = (registrationId: string): string => {
    if (storeWorkflowContextData(WorkflowContext.WorkingRegistrationId.toString(), registrationId)) {
        return registrationId;
    }
    return '';
};

export const storeExperianSessionId = (sessionId: string): string => {
    if (storeWorkflowContextData(WorkflowContext.EXPERIAN_SESSION_ID.toString(), sessionId)) {
        return sessionId;
    }
    return '';
};

export const storeUserInfo = (userInfo: string): string => {
    if (storeWorkflowContextData(WorkflowContext.USER_INFO.toString(), userInfo)) {
        return userInfo;
    }
    return '';
};

export const storeCurrentWorkflow = (workflow: Workflow): Workflow => {
    const workflowState = JSON.stringify(workflow);
    if (storeWorkflowContextData(WorkflowContext.WorkFlowData.toString(), workflowState)) {
        return workflow;
    }
    return initWorkflow();
};

export const getCurrentWorkflow = (): Workflow => {
    const workflowState = getWorkflowContextData(WorkflowContext.WorkFlowData.toString());
    if (workflowState === '') {
        return initWorkflow();
    }
    return JSON.parse(workflowState) as Workflow;
};

const initialState: State = {
    registrationId: getWorkflowContextData(WorkflowContext.WorkingRegistrationId.toString()),
    sessionId: getWorkflowContextData(WorkflowContext.EXPERIAN_SESSION_ID.toString()),
    userInfo: getWorkflowContextData(WorkflowContext.USER_INFO.toString()),
    workflow: getCurrentWorkflow(),
    checkRetry: false,
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.ACTION_SERVER_DATA_REQUESTED:
            return {
                ...state,
            };

        case types.ACTION_SERVER_DATA_FAILED:
            return {
                ...state,
            };

        case types.STORE_REGISTRATION_ID:
            return {
                ...state,
                registrationId: storeWorkingRegistrationId(action.registrationId)
            };

        case types.STORE_SESSION_ID:
            return {
                ...state,
                sessionId: storeExperianSessionId(action.sessionId)
            };

        case types.STORE_USER_INFOR:
            return {
                ...state,
                userInfo: storeUserInfo(action.userInfo)
            };

        case types.STORE_WORKFLOW_DATA:
            return {
                ...state,
                workflow: storeCurrentWorkflow(action.workflow)
            };

        case types.CHECK_RETRY:
            return {
                ...state,
                checkRetry: action.checkRetry
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/workflow/reducer.ts